import {
	CommonTable,
	DietRequiredInfo,
	DriverDiet,
	DriverDietKind,
	driverDietKindMapping,
} from '@/drivers/driver.model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Modal } from 'bootstrap';

import { Data2Service } from 'src/app/common/data2.service';
import { DateService } from 'src/app/common/date.service';
import { InfoboxService } from 'src/app/common/infobox/infobox.service';
import { LoaderService } from 'src/app/common/loader/loader.service';

@Component({
	selector: 'app-drivers-diet-set',
	templateUrl: './drivers-diet-set.component.html',
})
export class DriversDietSetComponent implements OnInit {
	@Input() driver: string;
	@Input() selectedMonth: string;
	@Output() changeMonth = new EventEmitter();

	data: DriverDiet = {
		id: null,
		driver: null,
		dateFrom: null,
		dateTo: null,
		kind: null,
		createdBy: null,
	};
	error: DietRequiredInfo = {
		dateRange: false,
	};
	tableRows: CommonTable[] = [
		{ id: 'dateFrom', name: 'Data od' },
		{ id: 'dateTo', name: 'Data do' },
		{ id: 'kindName', name: 'Rodzaj' },
	];
	cashOutKind: CommonTable[] = [
		{ id: DriverDietKind.TRANSFER, name: driverDietKindMapping[DriverDietKind.TRANSFER] },
		{ id: DriverDietKind.CASH, name: driverDietKindMapping[DriverDietKind.CASH] },
	];
	diets: DriverDiet[] = [];
	isItemBefore = false;
	isItemAfter = false;

	constructor(
		private readonly api: Data2Service,
		private readonly infobox: InfoboxService,
		private readonly loader: LoaderService,
		private readonly date: DateService,
	) {}

	ngOnInit(): void {
		this.loadData();
	}

	private loadData(): void {
		this.loader.show();
		this.api.get(`/driver/driverDiet/?driver=${this.driver}`, (result, error) => {
			if (!result) return;
			this.diets = result.data.map((diet) => {
				switch (diet.kind) {
					case DriverDietKind.TRANSFER:
						diet.kindName = driverDietKindMapping[DriverDietKind.TRANSFER];
						break;
					case DriverDietKind.CASH:
						diet.kindName = driverDietKindMapping[DriverDietKind.CASH];
						break;
				}
				return diet;
			});
		});
	}

	submit(): void {
		if (!this.data.id) {
			this.api.post(`/driver/driverDiet/`, this.data, (result, error) => {
				if (error) {
					return;
				}
				this.loadData();
			});
		} else {
			this.api.put(`/driver/driverDiet/${this.data.id}/`, this.data, (result, error) => {
				if (error) {
					return;
				}
				this.infobox.success('Zapisano');
				this.loadData();
			});
		}
		this.dialogClose();
	}

	openModal(): void {
		this.data = {
			id: null,
			driver: this.driver,
			dateFrom: this.date.now().date,
			dateTo: null,
			kind: null,
			createdBy: null,
		};
		this.isItemAfter = false;
		this.isItemBefore = this.diets?.length > 0;
		if (this.isItemBefore) {
			const lastOwner = this.diets[this.diets.length - 1];
			if (!lastOwner.dateTo) {
				this.infobox.error('Uzupełnij datę końcową');
				return;
			}
			this.data.dateFrom = this.date.addDays(1, lastOwner.dateTo);
		}
		new Modal(document.getElementById('dietSetModal')).show();
	}

	dialogClose(): void {
		const modal = Modal.getInstance(document.getElementById('dietSetModal'));
		if (!modal) {
			return;
		}
		modal.hide();
	}

	setDiet(row: { id: string }): void {
		this.data = this.diets?.find((obj) => obj.id === row.id);
		const positionInArray = this.diets.indexOf(this.data);
		this.isItemBefore = positionInArray !== 0;
		this.isItemAfter = positionInArray !== this.diets.length - 1;
		new Modal(document.getElementById('dietSetModal')).show();
	}
}
